import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

const getLanguageFromQuery = () => {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang");
  return lang === "en" || lang === "ar" ? lang : null;
};

export const LanguageProvider = ({ children }) => {
  // Initialize language state with the value from localStorage, defaulting to 'en'
  const [language, setLanguage] = useState(() => {
    const queryLang = getLanguageFromQuery();
    if (queryLang) {
      localStorage.setItem("language", queryLang);
      return queryLang;
    }

    const storedLanguage = localStorage.getItem("language");
    return storedLanguage || "en"; // Default to 'en' if no value is found
  });

  // Function to toggle between English and Arabic
  const toggleLanguage = () => {
    setLanguage((prevLanguage) => {
      const newLanguage = prevLanguage === "en" ? "ar" : "en";
      // Save the new language to localStorage
      localStorage.setItem("language", newLanguage);
      return newLanguage;
    });
  };

  // Optional: Sync language state with localStorage on initial load
  useEffect(() => {
    const queryLang = getLanguageFromQuery();
    if (queryLang && queryLang !== language) {
      setLanguage(queryLang);
      localStorage.setItem("language", queryLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};